import React from 'react';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useActiveModules } from '../../hooks/useActiveModules'; 


const ModuleGrid = ({ userId, completedModules, accessibleModules, passageCounts, onModuleSelect }) => {
  const { activeModules, activeModulesIds, activeModulesLoading, activeModulesError } = useActiveModules();
  console.log('In ModuleGrid active modules=', activeModules)
  console.log('In ModuleGrid accessible modules=', accessibleModules)
  
  const renderModule = (module) => {
    const isCompleted = completedModules.includes(module.module_id);
    const isAccessible = accessibleModules.includes(module.module_id);

    let boxClass = 'module-box';
    let checkmark = null;
    if (isCompleted) {
      boxClass += ' completed';
      checkmark = <span className="checkmark">&#10004;</span>;
    } else if (isAccessible) {
      boxClass += ' accessible';
    } else {
      boxClass += ' locked';
    }

    return (
      <div
        key={module.module_id}
        className={boxClass}
        onClick={() => isAccessible && onModuleSelect(module.module_id)}
      >
        {checkmark}
        {module.module_name}
        <div className="passage-count">
          {passageCounts[module.module_id] || 0}/2 dialogues completed
        </div>
      </div>
    );
  };

  if (activeModulesLoading) {
    return <div className="loading">Loading modules...</div>;
  }

  return (
    <div className="module-grid">
      {activeModules.map(module => renderModule(module))}
    </div>
  );
}
  
export default ModuleGrid;

